import { Card, Typography } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { t } from "ttag";
import useStyles from "../BacnetUnitInfo/styles";

const ModbusUnitInfo = (props: any) => {
  const classes = useStyles();
  const { modbusUnit, siteName } = props;
  const { name, isEngaged } = modbusUnit || {};

  return (
    <Card className={classes.card}>
      <div className={classes.unitInfoHeader}>
        <Typography className={classes.unitInfoTitle}>
          {t`Modbus Unit Information`}
        </Typography>
        {!isEngaged && (
          <Typography className={classes.unitInfoDisconnectedText}>
            {t`- Modbus unit is not bound`}
          </Typography>
        )}
      </div>
      <div className={classes.itemsWrapper}>
        <div className={clsx(classes.item, classes.firstItem)} style={{ maxWidth: "50%" }}>
          <Typography className={classes.infoTitle}>{t`Name`}</Typography>
          <Typography className={clsx(classes.info, classes.limited20)}>{name}</Typography>
        </div>
        <div className={classes.item} style={{ maxWidth: "50%" }}>
          <Typography className={classes.infoTitle}>{t`Site Name`}</Typography>
          <Typography className={clsx(classes.info, classes.limited20)}>{siteName}</Typography>
        </div>
      </div>
    </Card>
  );
};

export default ModbusUnitInfo;
